import { Injectable, inject } from "@angular/core";
import { CommandManager } from "~app/common/services/cqs/commandManager";
import { UpdateKontraktChecklistaCommand } from "../commands/checklista/UpdateKontraktChecklistaCommand";
import { ChecklisteFragaModel, GruppWithFragor } from "../models/checklist-models";
import { KontraktMediatorService } from "./kontrakt-mediator.service";
import { VirkeskopService } from "./virkeskop.service";

@Injectable()
export class ChecklistMediatorService {
    private readonly virkeskopService = inject(VirkeskopService);
    private readonly kontraktMediatorService = inject(KontraktMediatorService);
    private readonly commandManager = inject(CommandManager);

    private _checklisteFragor: ChecklisteFragaModel[] = [];
    private _numberOfSelectedFragor: number;
    private _grupperWithFragor: GruppWithFragor[] = [];

    get numberOfSelectedFragor() { return this._numberOfSelectedFragor; }

    get checklisteFragor() { return this._checklisteFragor; }

    get grupperWithFragor() { return this._grupperWithFragor; }

    getChecklisteFragor() {
        this.virkeskopService.getChecklisteFragor(this.kontraktMediatorService.kontrakt.guid).subscribe({
            next: fragor => {
                this._checklisteFragor = fragor.map(value => ({
                    beskrivning: value.beskrivning,
                    id: value.id,
                    gruppNamn: value.grupp === "Fältarbete/Karta/Avverkningsdirektiv" ? "Fält./Karta/Avv." : value.grupp,
                    gruppId: value.gruppId,
                    selected: value.selected
                }));

                this._grupperWithFragor = this.checklisteFragor.reduce((groupedFragor, currentFraga) => {
                    const grupp = groupedFragor.find(g => g.gruppId === currentFraga.gruppId);
                    if (grupp) {
                        grupp.fragor.push(currentFraga);
                    } else {
                        groupedFragor.push({
                            gruppNamn: currentFraga.gruppNamn,
                            gruppId: currentFraga.gruppId,
                            fragor: [currentFraga]
                        });
                    }
                    return groupedFragor;
                }, [] as GruppWithFragor[]);

                this._numberOfSelectedFragor = this.checklisteFragor.filter(f => f.selected === true).length;
            }
        });
    }

    onSelectedChanged(updatedFraga: ChecklisteFragaModel, checked: boolean) {
        const fraga = this.checklisteFragor.find(f => f.id === updatedFraga.id);
        if (fraga) {
            fraga.selected = checked;
        }

        this._numberOfSelectedFragor = this.checklisteFragor.filter(f => f.selected === true).length;
        this.addCommand();
    }

    private addCommand(): void {
        const cmd = new UpdateKontraktChecklistaCommand(this.kontraktMediatorService.kontrakt.guid, this.checklisteFragor);
        this.commandManager.updateCommand(cmd);
    }
}
